// // import React, { useState, useRef, useEffect } from "react";
// // import Editor from "react-simple-code-editor";
// // import "prismjs/themes/prism-tomorrow.css";

// // export default function HttpEditorPro({ value, onChange, placeholder = "http:{…} را تایپ کنید" }) {
  
// //   const editorRef = useRef(null);

// //   // هایلایت سفارشی
// //   const highlightCode = (text) => {
// //     // تبدیل http:{…} به http:(…)
// //     const transformed = text.replace(/http:\{(.*?)\}/g, (_, p1) => {
// //       return `http:(${p1})`;
// //     });

// //     // اضافه کردن span برای هایلایت
// //     return transformed.replace(/http:\((.*?)\)/g, (_, p1) => {
// //       return `<span class="text-blue-500 font-semibold">http:(${p1})</span>`;
// //     });
// //   };

// //   // handle change با حفظ caret position
// //   const handleValueChange = (val) => {
// //     const editor = editorRef.current;
// //     if (!editor) return;

// //     const start = editor._input.selectionStart;
// //     const end = editor._input.selectionEnd;

// //     onChange(val);

// //     // حفظ caret position بعد از تغییر
// //     setTimeout(() => {
// //       editor._input.setSelectionRange(start, end);
// //     }, 0);
// //   };

// //   return (
// //     <div className="max-w-xl mx-auto mt-6">
// //       <label className="block text-gray-700 mb-2 font-medium">
// //         متن خود را وارد کنید:
// //       </label>
// //       <div className="relative border border-gray-300 rounded-lg overflow-hidden shadow-sm focus-within:ring-2 focus-within:ring-blue-400">
// //         <Editor
// //           ref={editorRef}
// //           value={value}
// //           onValueChange={handleValueChange}
// //           highlight={(code) => highlightCode(code)}
// //           padding={12}
// //           style={{
// //             fontFamily: '"Fira Code", monospace',
// //             fontSize: 16,
// //             minHeight: "120px",
// //             outline: "none",
// //             whiteSpace: "pre-wrap",
// //             wordWrap: "break-word",
// //           }}
// //           textareaClassName="w-full bg-transparent focus:outline-none"
// //         />
// //       </div>
// //       <p className="mt-2 text-sm text-gray-500">
// //         تایپ به شکل <code>http:{'{…}'}</code> و مشاهده هایلایت زنده.
// //       </p>
// //     </div>
// //   );
// // }
// import React, { useRef } from "react";
// import Editor from "react-simple-code-editor";
// import "prismjs/themes/prism-tomorrow.css";

// export default function HttpEditor({ value, onChange, placeholder = "http:{…} را تایپ کنید" }) {
//   const textareaRef = useRef(null);

//   // هایلایت سفارشی
//   const highlightCode = (text) => {
//     // تبدیل http:{…} به http:(…)
//     const transformed = text.replace(/http:\{(.*?)\}/g, (_, p1) => `http:(${p1})`);
//     // اضافه کردن span برای هایلایت
//     return transformed.replace(/http:\((.*?)\)/g, (_, p1) => {
//       return `<span class="text-blue-500 font-semibold">http:(${p1})</span>`;
//     });
//   };

//   const handleValueChange = (val) => {
//     // ذخیره در parent
//     onChange(val);

//     // caret position حفظ می‌شود
//     setTimeout(() => {
//       if (!textareaRef.current) return;
//       const start = textareaRef.current.selectionStart;
//       const end = textareaRef.current.selectionEnd;
//       textareaRef.current.setSelectionRange(start, end);
//     }, 0);
//   };

//   return (
//     <div className="relative border border-gray-300 rounded-lg overflow-hidden shadow-sm focus-within:ring-2 focus-within:ring-blue-400">
//       <Editor
//         value={value}
//         onValueChange={handleValueChange}
//         highlight={(code) => highlightCode(code)}
//         padding={12}
//         textareaProps={{ ref: textareaRef }}
//         style={{
//           fontFamily: '"Fira Code", monospace',
//           fontSize: 16,
//           minHeight: "120px",
//           outline: "none",
//           whiteSpace: "pre-wrap",
//           wordWrap: "break-word",
//         }}
//         textareaClassName="w-full bg-transparent focus:outline-none"
//       />
//       {placeholder && value.length === 0 && (
//         <span className="absolute top-2 left-3 text-gray-400 pointer-events-none">{placeholder}</span>
//       )}
//     </div>
//   );
// }
// import React, { useRef } from "react";
// import Editor from "react-simple-code-editor";
// import "prismjs/themes/prism-tomorrow.css";

// export default function HttpEditorPro({ value, onChange, placeholder = "http:{…} را تایپ کنید" }) {
//   const textareaRef = useRef(null);

//   // هایلایت سفارشی فقط محتوای داخل {} را رنگی می‌کند
//   const highlightCode = (text) => {
//     return text.replace(/http:\{(.*?)\}/g, (_, p1) => {
//       return `http:{<span class="text-blue-500 font-semibold">${p1}</span>}`;
//     });
//   };

//   const handleValueChange = (val) => {
//     // ذخیره در parent
//     onChange(val);

//     // caret position سمت چپ درست شود
//     setTimeout(() => {
//       if (!textareaRef.current) return;
//       const start = textareaRef.current.selectionStart;
//       const end = textareaRef.current.selectionEnd;
//       textareaRef.current.setSelectionRange(start, end);
//     }, 0);
//   };

//   return (
//     <div className="relative border border-gray-300 rounded-lg overflow-hidden shadow-sm focus-within:ring-2 focus-within:ring-blue-400">
//       <Editor
//         value={value}
//         onValueChange={handleValueChange}
//         highlight={(code) => highlightCode(code)}
//         padding={12}
//         textareaProps={{ ref: textareaRef }}
//         style={{
//           fontFamily: '"Fira Code", monospace',
//           fontSize: 16,
//           minHeight: "120px",
//           outline: "none",
//           whiteSpace: "pre-wrap",
//           wordWrap: "break-word",
//           direction: "ltr", // تایپ از سمت چپ
//           textAlign: "left", // متن از سمت چپ
//         }}
//         textareaClassName="w-full bg-transparent focus:outline-none"
//       />
//       {placeholder && value.length === 0 && (
//         <span className="absolute top-2 left-3 text-gray-400 pointer-events-none">{placeholder}</span>
//       )}
//     </div>
//   );
// }
import React, { useState, useRef } from "react";
import Editor from "react-simple-code-editor";
import "prismjs/themes/prism-tomorrow.css";

export default function HttpEditor({ value, onChange, placeholder = "http:{…}" }) {
  const textareaRef = useRef(null);
  const [internalValue, setInternalValue] = useState(value || "");

  // هایلایت سفارشی: محتوای داخل {} هایلایت می‌شود
  const highlightCode = (text) => {
    return text.replace(/http:\{(.*?)\}/g, (_, p1) => {
      return `http:<span class="text-[#213e39] bg-[#FFC505] p-1 rounded-full font-semibold">${p1}</span>`;
    });
  };

  const handleValueChange = (val) => {
    // ابتدا state داخلی را به‌روز می‌کنیم
    setInternalValue(val);

    // تبدیل متن: وقتی {} بسته شد، به http:… تبدیل می‌کنیم
    const transformed = val.replace(/http:\{(.*?)\}/g, (_, p1) => `http:${p1}`);

    // مقدار به parent پاس داده می‌شود
    onChange(transformed);

    // caret position سمت چپ
    setTimeout(() => {
      if (!textareaRef.current) return;
      const start = textareaRef.current.selectionStart;
      const end = textareaRef.current.selectionEnd;
      textareaRef.current.setSelectionRange(start, end);
    }, 0);
  };

  return (
    <div className="relative border border-gray-300 rounded-lg overflow-hidden shadow-sm focus-within:ring-2 focus-within:ring-[#FFC505]">
      <Editor
        value={internalValue}
        onValueChange={handleValueChange}
        highlight={(code) => highlightCode(code)}
        padding={12}
        textareaProps={{ ref: textareaRef }}
        style={{
          fontFamily: '"Fira Code", monospace',
          fontSize: 16,
          minHeight: "35px",
          outline: "none",
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
          direction: "ltr",
          textAlign: "left",
          backgroundColor:"white"
        }}
        textareaClassName="w-full bg-transparent focus:outline-none"
      />
      {placeholder && internalValue.length === 0 && (
        <span className="absolute top-2 left-3 text-gray-400 pointer-events-none ltr"
        style={{
            padding: 4,        
            direction: "ltr",  
            textAlign: "left",  
            fontSize:"16px"
          }}
        >{placeholder}</span>
      )}
    </div>
  );
}
